import React, { FC } from 'react'
import {
  Box,
  BoxProps,
  Radio as RadioChakra,
  RadioProps,
  ThemingProps
} from '@chakra-ui/react'
import { css } from '@emotion/react'
import { isIE } from 'shared/helpers'
import {
  fontSizes,
  getCustomTheme
} from 'front-end/src/components/chakraThemeExtension'
import { Tooltip } from 'front-end/src/components'

export const Radio: FC<
  RadioProps & {
    colorScheme?: ThemingProps['colorScheme']
    tooltipText?: string | undefined
    dataTest?: string
  }
> = ({ tooltipText, dataTest = 'Radio', ...rest }) => {
  const content = (
    <Box
      css={
        isIE
          ? css`
              input {
                width: auto !important;
                height: auto !important;
                clip: auto !important;
                position: static !important;
              }
              .chakra-radio__control {
                display: none !important;
              }
            `
          : undefined
      }
    >
      <RadioChakra position="relative" data-test={dataTest} {...rest} />
    </Box>
  )
  return tooltipText ? <Tooltip text={tooltipText}>{content}</Tooltip> : content
}

export const RadioDescription: FC<BoxProps> = (props) => {
  const theme = getCustomTheme()

  return (
    <Box
      color={theme.colors.grey[500]}
      mt="6px"
      fontSize={fontSizes.ssm}
      lineHeight="16px"
      {...props}
    />
  )
}
